module.exports = __webpack_public_path__ + "assets/img/00050.9d131184.png";